// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__hJ1SH","social":"socials__social__YtMpc","rtlSocial":"socials__rtlSocial__OLN8Q","icon":"socials__icon__Hgj3e","navOpen":"socials__navOpen__O_38W"};